import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../../../components/InputField";
import SelectField from "../../../../components/SelectField";
import Button from "../../../../components/Button";
import { Modal } from "react-bootstrap";
import api from "../../../../api/api";
import Select from "react-select";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useAuth } from "../../../../context/AuthContext";
import BackButton from "../../../../components/BackButton";
 
const validationSchema = Yup.object().shape({
  incoterm: Yup.string().required("Incoterm is required"),
  first_shipper_name: Yup.string().required("Shipper Name is required"),
  first_consignee_name: Yup.string().required("Consignee Name is required"),
  pol: Yup.string().required("Port of Loading is required"),
  pod: Yup.string().required("Port of Discharge is required"),
  freight_terms: Yup.string().required("Freight Terms is required"),
 
  place_of_receipt: Yup.string(),
  place_of_receipt_pin: Yup.string().when("incoterm", ([incoterm], schema) =>
    ["Door to Door", "Door to Port"].includes(incoterm)
      ? schema.required("POR Pin Code is required")
      : schema.notRequired(),
  ),
  final_port_of_delivery: Yup.string(),
  final_port_of_delivery_pin: Yup.string().when("incoterm", ([incoterm], schema) =>
    ["Door to Door", "Port to Door", "ICD to Door"].includes(incoterm)
      ? schema.required("FPOD Pin Code is required")
      : schema.notRequired(),
  ),
 
  routing: Yup.string().required("Routing is required"),
  transshipment_hub: Yup.string().when("routing", ([routing], schema) =>
    ["Indirect", "Both"].includes(routing)
      ? schema.required("Transshipment Hub is required")
      : schema.notRequired(),
  ),
 
  shipment_segment: Yup.string().required("Shipment Segment is required"),
  stuffing_destuffing_At: Yup.string().when(
    "shipment_segment",
    ([segment], schema) =>
      ["FE", "LE", "FI", "LI"].includes(segment)
        ? schema.required("Location is required")
        : schema.notRequired(),
  ),
  nature_of_cargo: Yup.string().required("Nature of Cargo is required"),
  haz_class: Yup.string().when("nature_of_cargo", ([cargo], schema) =>
    cargo === "Hazardous"
      ? schema.required("HAZ Class is required")
      : schema.notRequired(),
  ),
  document_type: Yup.string().required("Document Type is required"),
  document_count: Yup.string().when("document_type", ([docType], schema) =>
    docType === "Original"
      ? schema.required("Document Count is required")
      : schema.notRequired(),
  ),
  switch_bl: Yup.string(),
  switch_at: Yup.string().when("switch_bl", ([switchBl], schema) =>
    switchBl === "Yes"
      ? schema.required("Switch At is required")
      : schema.notRequired(),
  ),
 
  hs_code: Yup.string(),
  hsn_description: Yup.string().required("HSN Description is required"),
 
  containers: Yup.array().min(1, "At least one container is required"),
  packaging_type: Yup.string().required("Packaging Type is required"),
  packaging_count: Yup.string().required("Packaging Count is required"),
  remarks: Yup.string(),
  goods_value: Yup.string().required("Goods value is required"),
});
 
const EditEnquiry = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
 
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [portsOptions, setPortsOptions] = useState([]);
 
  const [inputRow, setInputRow] = useState({
    containerType: "",
    weight: "",
    length: "",
    breadth: "",
    height: "",
    temperature: "",
  });
 
  const containerOptions = [
    { value: "20'Standard", label: "20'Standard" },
    { value: "20'Open Top", label: "20'Open Top" },
    { value: "20'Reefer", label: "20'Reefer" },
    { value: "20'Flat Rack", label: "20'Flat Rack" },
    { value: "20'Platform", label: "20'Platform" },
    { value: "20'Flexi Tank", label: "20'Flexi Tank" },
    { value: "20'ISO Tank", label: "20'ISO Tank" },
    { value: "20'Hard Top", label: "20'Hard Top" },
    { value: "20'Collapsible", label: "20'Collapsible" },
    { value: "40'Standard", label: "40'Standard" },
    { value: "40'High Cube", label: "40'High Cube" },
    { value: "40'Open top", label: "40'Open top" },
    { value: "40'Reefer", label: "40'Reefer" },
    { value: "40'Flat Rack", label: "40'Flat Rack" },
    { value: "40'Platform", label: "40'Platform" },
    { value: "40'Flexi Tank", label: "40'Flexi Tank" },
    { value: "40'ISO Tank", label: "40'ISO Tank" },
    { value: "40'Hard Top", label: "40'Hard Top" },
    { value: "40'Collapsible Flat Rack", label: "40'Collapsible Flat Rack" },
  ];
 
  const incotermOptions = [
    "Port to Port",
    "Door to Door",
    "Door to Port",
    "Port to Door",
    "ICD to Port",
    "ICD to Door",
  ];
 
  const routingOptions = ["Direct", "Indirect", "Both"];
  const shipmentSegmentOptions = ["FE", "LE", "FI", "LI"];
  const stuffingDestuffingOptions = ["Factory", "Port"];
 
  const natureOfCargoOptions = [
    "Hazardous",
    "Non Hazardous",
    "Temperature Control",
    "Moisture Control",
    "Heavy Duty",
    "Over Dimensional Cargo",
  ];
  const documentTypeOptions = ["Original", "Seaway"];
  const switchBlOptions = [
    { value: "No", label: "No" },
    { value: "Yes", label: "Yes" },
  ];
  const freighttermsOptions = ["Prepaid", "Collect"];
 
  const formik = useFormik({
    initialValues: {
      incoterm: "",
      first_shipper_name: "",
      first_consignee_name: "",
      pol: "",
      pod: "",
      freight_terms: "",
      place_of_receipt: "",
      place_of_receipt_pin: "",
      final_port_of_delivery: "",
      cha_required: "",
      final_port_of_delivery_pin: "",
      routing: "",
      transhipment_hub: "",
      shipment_segment: "",
      stuffing_destuffing_At: "",
      nature_of_cargo: "",
      haz_class: "",
      document_type: "",
      document_count: "",
      switch_bl: "No",
      switch_at: "",
      hs_code: "",
      hs_description: "",
      packaging_type: "",
      packaging_count: "",
      goods_value: "",
      remarks: "",
      containers: [],
    },
    validationSchema,
    onSubmit: (values) => {
      console.log("Submitted", values);
      setShowConfirm(true);
    },
  });
 
  useEffect(() => {
    const fetchPorts = async () => {
      try {
        const res = await api.get("/ports");
        const options = res.data.map((p) => ({
          value: p.Port_names,
          label: p.Port_names,
        }));
        setPortsOptions(options);
      } catch (err) {
        console.error("Error fetching ports:", err);
      }
    };
 
    const fetchData = async () => {
      try {
        const res = await api.get(`/enquiry/viewEnquiry/${id}`);
        const enquiryData = res.data;
 
        const formattedContainers =
          enquiryData.containerDetails?.map((c) => ({
            container_id: c.container_id,
            container_type: c.container_type || "",
            container_weight: c.container_weight || 0,
            container_length: c.container_length || 0,
            container_breadth: c.container_breadth || 0,
            container_height: c.container_height || 0,
            container_temperature: c.container_temperature || 0,
          })) || [];
 
        formik.resetForm({
          values: {
            ...formik.initialValues,
            ...enquiryData,
            first_shipper_name: enquiryData.first_shipper_name || "",
            first_consignee_name: enquiryData.first_consignee_name || "",
            containers: formattedContainers,
          },
        });
      } catch (error) {
        console.error("Error fetching enquiry:", error);
      } finally {
        setLoading(false);
      }
    };
 
    fetchPorts();
    fetchData();
  }, [id]);
 
  const handleAddRow = () => {
    const isFE_FI = ["FE", "FI"].includes(formik.values.shipment_segment);
    if (
      !inputRow.containerType &&
      (isFE_FI || !["LE", "LI"].includes(formik.values.shipment_segment))
    ) {
      alert("Please select a container type");
      return;
    }
 
    const newContainer = {
      container_type: inputRow.containerType,
      container_weight: inputRow.weight || 0,
      container_length: inputRow.length || 0,
      container_breadth: inputRow.breadth || 0,
      container_height: inputRow.height || 0,
      container_temperature: inputRow.temperature || 0,
    };
 
    const updatedContainers = [...formik.values.containers, newContainer];
    formik.setFieldValue("containers", updatedContainers);
 
    setInputRow({
      containerType: "",
      weight: "",
      length: "",
      breadth: "",
      height: "",
      temperature: "",
    });
  };
 
  const handleRemoveRow = (index) => {
    const updatedContainers = formik.values.containers.filter(
      (_, i) => i !== index,
    );
    formik.setFieldValue("containers", updatedContainers);
  };
 
  const handleConfirm = async () => {
    try {
      await api.put(`/enquiry/updateEnquiry/${id}`, formik.values);
      setShowConfirm(false);
      setShowSuccess(true);
    } catch (err) {
      console.error("Error updating enquiry:", err);
      setShowConfirm(false);
    }
  };
 
  const handleSuccessClose = () => {
    setShowSuccess(false);
    if (user?.user_role === "sales_rep") {
      navigate("/freight-enquiries");
    } else {
      navigate("/my-enquiry/view-enquiry");
    }
  };
 
  const getFieldError = (fieldName) =>
    formik.touched[fieldName] && formik.errors[fieldName]
      ? formik.errors[fieldName]
      : "";
 
  const hasFieldError = (fieldName) =>
    Boolean(formik.touched[fieldName] && formik.errors[fieldName]);
 
  const isLE_LI = ["LE", "LI"].includes(formik.values.shipment_segment);
  const isFE_FI = ["FE", "FI"].includes(formik.values.shipment_segment);
 
  if (loading) return <p className="text-center mt-4">Loading enquiry...</p>;
 
  return (
    <>
      <BackButton />
      <form onSubmit={formik.handleSubmit} >
        <div className="row g-3">
          {/* 1. Incoterm */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Incoterm</label>
            <Select
              options={incotermOptions.map((i) => ({ value: i, label: i }))}
              placeholder="Select Incoterm"
              value={
                formik.values.incoterm
                  ? {
                      value: formik.values.incoterm,
                      label: formik.values.incoterm,
                    }
                  : null
              }
              onChange={(opt) =>
                formik.setFieldValue("incoterm", opt?.value || "")
              }
              onBlur={() => formik.setFieldTouched("incoterm", true)}
              isClearable
            />
            {hasFieldError("incoterm") && (
              <div className="text-danger small mt-1">
                {getFieldError("incoterm")}
              </div>
            )}
          </div>
 
          {/* 1.1 Shipper Name */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Shipper Name</label>
            <InputField
              name="first_shipper_name"
              value={formik.values.first_shipper_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {hasFieldError("first_shipper_name") && (
              <div className="text-danger small mt-1">
                {getFieldError("first_shipper_name")}
              </div>
            )}
          </div>
 
          {/*  Consignee Name */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Consignee Name</label>
            <InputField
              name="first_consignee_name"
              value={formik.values.first_consignee_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {hasFieldError("first_consignee_name") && (
              <div className="text-danger small mt-1">
                {getFieldError("first_consignee_name")}
              </div>
            )}
          </div>
 
          {/*  Place Of Receipt (POR) */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Place Of Receipt</label>
            <InputField
              name="place_of_receipt"
              value={formik.values.place_of_receipt}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {hasFieldError("place_of_receipt") && (
              <div className="text-danger small mt-1">
                {getFieldError("place_of_receipt")}
              </div>
            )}
          </div>
 
          {/*  POR Pin Code */}
          {["Door to Door", "Door to Port"].includes(
            formik.values.incoterm,
          ) && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">POR Pin Code</label>
              <InputField
                name="place_of_receipt_pin"
                value={formik.values.place_of_receipt_pin}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {hasFieldError("place_of_receipt_pin") && (
                <div className="text-danger small mt-1">
                  {getFieldError("place_of_receipt_pin")}
                </div>
              )}
            </div>
          )}
 
          {/*  Port of Loading */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Port of Loading</label>
            <Select
              options={portsOptions}
              value={
                portsOptions.find((p) => p.value === formik.values.pol) || null
              }
              onChange={(opt) => formik.setFieldValue("pol", opt?.value || "")}
              onBlur={() => formik.setFieldTouched("pol", true)}
              isClearable
            />
            {hasFieldError("pol") && (
              <div className="text-danger small mt-1">
                {getFieldError("pol")}
              </div>
            )}
          </div>
 
          {/*  Port of Discharge */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Port of Discharge</label>
            <Select
              options={portsOptions}
              value={
                portsOptions.find((p) => p.value === formik.values.pod) || null
              }
              onChange={(opt) => formik.setFieldValue("pod", opt?.value || "")}
              onBlur={() => formik.setFieldTouched("pod", true)}
              isClearable
            />
            {hasFieldError("pod") && (
              <div className="text-danger small mt-1">
                {getFieldError("pod")}
              </div>
            )}
          </div>
 
          {/*  Final Port Of Delivery (FPOD) */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Final Port Of Delivery</label>
            <InputField
              name="final_port_of_delivery"
              value={formik.values.final_port_of_delivery}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {hasFieldError("final_port_of_delivery") && (
              <div className="text-danger small mt-1">
                {getFieldError("final_port_of_delivery")}
              </div>
            )}
          </div>
 
          {/*  FPOD Pin Code */}
          {["Door to Door", "Port to Door", "ICD to Door"].includes(
            formik.values.incoterm,
          ) && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">FPOD Pin Code</label>
              <InputField
                name="final_port_of_delivery_pin"
                value={formik.values.final_port_of_delivery_pin}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {hasFieldError("final_port_of_delivery_pin") && (
                <div className="text-danger small mt-1">
                  {getFieldError("final_port_of_delivery_pin")}
                </div>
              )}
            </div>
          )}
 
          {/*  Routing */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Routing</label>
            <Select
              options={routingOptions.map((r) => ({ value: r, label: r }))}
              placeholder="Select Routing"
              value={
                formik.values.routing
                  ? {
                      value: formik.values.routing,
                      label: formik.values.routing,
                    }
                  : null
              }
              onChange={(opt) =>
                formik.setFieldValue("routing", opt?.value || "")
              }
              onBlur={() => formik.setFieldTouched("routing", true)}
              isClearable
            />
            {hasFieldError("routing") && (
              <div className="text-danger small mt-1">
                {getFieldError("routing")}
              </div>
            )}
          </div>
 
          {/*  Transshipment Hub */}
          {["Indirect", "Both"].includes(formik.values.routing) && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Transshipment Hub</label>
              <Select
                options={portsOptions}
                value={
                  portsOptions.find(
                    (p) => p.value === formik.values.transshipment_hub,
                  ) || null
                }
                onChange={(opt) =>
                  formik.setFieldValue("transshipment_hub", opt?.value || "")
                }
                onBlur={() => formik.setFieldTouched("transshipment_hub", true)}
                isClearable
              />
              {hasFieldError("transshipment_hub") && (
                <div className="text-danger small mt-1">
                  {getFieldError("transshipment_hub")}
                </div>
              )}
            </div>
          )}
 
          {/*  Freight Terms */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Freight Terms</label>
            <Select
              options={freighttermsOptions.map((i) => ({ value: i, label: i }))}
              placeholder="Select Freight Terms"
              value={
                formik.values.freight_terms
                  ? {
                      value: formik.values.freight_terms,
                      label: formik.values.freight_terms,
                    }
                  : null
              }
              onChange={(opt) =>
                formik.setFieldValue("freight_terms", opt?.value || "")
              }
              onBlur={() => formik.setFieldTouched("freight_terms", true)}
              isClearable
            />
            {hasFieldError("freight_terms") && (
              <div className="text-danger small mt-1">
                {getFieldError("freight_terms")}
              </div>
            )}
          </div>
 
          {/*  Shipment Segment */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Shipment Segment</label>
            <Select
              options={shipmentSegmentOptions.map((i) => ({
                value: i,
                label: i,
              }))}
              placeholder="Select Segment"
              value={
                formik.values.shipment_segment
                  ? {
                      value: formik.values.shipment_segment,
                      label: formik.values.shipment_segment,
                    }
                  : null
              }
              onChange={(opt) =>
                formik.setFieldValue("shipment_segment", opt?.value || "")
              }
              onBlur={() => formik.setFieldTouched("shipment_segment", true)}
              isClearable
            />
            {hasFieldError("shipment_segment") && (
              <div className="text-danger small mt-1">
                {getFieldError("shipment_segment")}
              </div>
            )}
          </div>
 
          {/* Stuffing At */}
          {["FE", "LE"].includes(formik.values.shipment_segment) && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Stuffing At</label>
              <Select
                options={stuffingDestuffingOptions.map((opt) => ({
                  value: opt,
                  label: opt,
                }))}
                placeholder="Select Stuffing Location"
                value={
                  formik.values.stuffing_destuffing_At
                    ? {
                        value: formik.values.stuffing_destuffing_At,
                        label: formik.values.stuffing_destuffing_At,
                      }
                    : null
                }
                onChange={(opt) =>
                  formik.setFieldValue(
                    "stuffing_destuffing_At",
                    opt?.value || "",
                  )
                }
                onBlur={() =>
                  formik.setFieldTouched("stuffing_destuffing_At", true)
                }
                isClearable
              />
              {hasFieldError("stuffing_destuffing_At") && (
                <div className="text-danger small mt-1">
                  {getFieldError("stuffing_destuffing_At")}
                </div>
              )}
            </div>
          )}
 
          {/* Destuffing At */}
          {["FI", "LI"].includes(formik.values.shipment_segment) && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Destuffing At</label>
              <Select
                options={stuffingDestuffingOptions.map((opt) => ({
                  value: opt,
                  label: opt,
                }))}
                placeholder="Select Destuffing Location"
                value={
                  formik.values.stuffing_destuffing_At
                    ? {
                        value: formik.values.stuffing_destuffing_At,
                        label: formik.values.stuffing_destuffing_At,
                      }
                    : null
                }
                onChange={(opt) =>
                  formik.setFieldValue(
                    "stuffing_destuffing_At",
                    opt?.value || "",
                  )
                }
                onBlur={() =>
                  formik.setFieldTouched("stuffing_destuffing_At", true)
                }
                isClearable
              />
              {hasFieldError("stuffing_destuffing_At") && (
                <div className="text-danger small mt-1">
                  {getFieldError("stuffing_destuffing_At")}
                </div>
              )}
            </div>
          )}
 
          {/* 12. Nature of Cargo */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Nature of Cargo</label>
            <Select
              options={natureOfCargoOptions.map((i) => ({
                value: i,
                label: i,
              }))}
              placeholder="Select Cargo Type"
              value={
                formik.values.nature_of_cargo
                  ? {
                      value: formik.values.nature_of_cargo,
                      label: formik.values.nature_of_cargo,
                    }
                  : null
              }
              onChange={(opt) =>
                formik.setFieldValue("nature_of_cargo", opt?.value || "")
              }
              onBlur={() => formik.setFieldTouched("nature_of_cargo", true)}
              isClearable
            />
            {hasFieldError("nature_of_cargo") && (
              <div className="text-danger small mt-1">
                {getFieldError("nature_of_cargo")}
              </div>
            )}
          </div>
 
          {formik.values.nature_of_cargo === "Hazardous" && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">HAZ Class</label>
              <InputField
                name="haz_class"
                value={formik.values.haz_class}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {hasFieldError("haz_class") && (
                <div className="text-danger small mt-1">
                  {getFieldError("haz_class")}
                </div>
              )}
            </div>
          )}
 
          {/* 13. Document Type */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Document Type</label>
            <Select
              options={documentTypeOptions.map((i) => ({ value: i, label: i }))}
              placeholder="Select Document Type"
              value={
                formik.values.document_type
                  ? {
                      value: formik.values.document_type,
                      label: formik.values.document_type,
                    }
                  : null
              }
              onChange={(opt) =>
                formik.setFieldValue("document_type", opt?.value || "")
              }
              onBlur={() => formik.setFieldTouched("document_type", true)}
              isClearable
            />
            {hasFieldError("document_type") && (
              <div className="text-danger small mt-1">
                {getFieldError("document_type")}
              </div>
            )}
          </div>
 
          {formik.values.document_type === "Original" && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Document Count</label>
              <InputField
                name="document_count"
                value={formik.values.document_count}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {hasFieldError("document_count") && (
                <div className="text-danger small mt-1">
                  {getFieldError("document_count")}
                </div>
              )}
            </div>
          )}
 
          {/* 14. Switch BL */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Switch BL</label>
            <Select
              options={switchBlOptions}
              value={
                switchBlOptions.find(
                  (opt) => opt.value === formik.values.switch_bl,
                ) || switchBlOptions[0]
              }
              onChange={(val) =>
                formik.setFieldValue("switch_bl", val ? val.value : "")
              }
            />
          </div>
 
          {formik.values.switch_bl === "Yes" && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Switch At</label>
              <Select
                options={portsOptions}
                value={
                  portsOptions.find(
                    (opt) => opt.value === formik.values.switch_at,
                  ) || null
                }
                onChange={(val) =>
                  formik.setFieldValue("switch_at", val ? val.value : "")
                }
                isSearchable
                placeholder="Select Port..."
              />
              {hasFieldError("switch_at") && (
                <div className="text-danger small mt-1">
                  {getFieldError("switch_at")}
                </div>
              )}
            </div>
          )}
 
          {/* 15. HS Code */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">HS Code</label>
            <InputField
              name="hs_code"
              value={formik.values.hs_code}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
 
          {/* 16. Cargo/HSN Description */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">HSN Description</label>
            <InputField
              name="hs_description"
              value={formik.values.hs_description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {hasFieldError("hs_description") && (
              <div className="text-danger small mt-1">
                {getFieldError("hs_description")}
              </div>
            )}
          </div>
 
          {/* Packaging and Additional Details */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Packaging Type</label>
            <InputField
              name="packaging_type"
              value={formik.values.packaging_type}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {hasFieldError("packaging_type") && (
              <div className="text-danger small mt-1">
                {getFieldError("packaging_type")}
              </div>
            )}
          </div>
 
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Packaging Count</label>
            <InputField
              name="packaging_count"
              value={formik.values.packaging_count}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {hasFieldError("packaging_count") && (
              <div className="text-danger small mt-1">
                {getFieldError("packaging_count")}
              </div>
            )}
          </div>
 
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Goods Value</label>
            <InputField
              name="goods_value"
              value={formik.values.goods_value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {hasFieldError("goods_value") && (
              <div className="text-danger small mt-1">
                {getFieldError("goods_value")}
              </div>
            )}
          </div>
 
          {/* 17. Dynamic Containers Table */}
          <div className="col-12 position-relative">
            <div className="position-absolute measurement d-none d-lg-block">
              <p>1M = 100CM</p>
              <p>1CM = 10MM</p>
            </div>
 
            <table className="table table-bordered tbllbl mb-2 mb-md-3">
              <thead className="table-light">
                <tr>
                  {!isLE_LI && <th>Container Type</th>}
                  {!isLE_LI && <th>Gross Cargo Weight</th>}
                  {!isFE_FI && <th>Length</th>}
                  {!isFE_FI && <th>Breadth</th>}
{!isFE_FI && <th>Height</th>}
                   {isLE_LI && <th>CBM</th>}
                   {formik.values.nature_of_cargo === "Temperature Control" && (
                    <th>Temperature</th>
                  )}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {/* Input Row */}
                <tr>
                  {!isLE_LI && (
                    <td>
                      <Select
                        value={
                          inputRow.containerType
                            ? {
                                value: inputRow.containerType,
                                label: inputRow.containerType,
                              }
                            : null
                        }
                        onChange={(opt) =>
                          setInputRow((prev) => ({
                            ...prev,
                            containerType: opt?.value || "",
                          }))
                        }
                        options={containerOptions}
                        placeholder="Select Container"
                        isClearable
                      />
                    </td>
                  )}
                  {!isLE_LI && (
                    <td>
                      <InputField
                        type="number"
                        placeholder="Weight in kg's"
                        value={inputRow.weight}
                        onChange={(e) =>
                          setInputRow((prev) => ({
                            ...prev,
                            weight: e.target.value,
                          }))
                        }
                      />
                    </td>
                  )}
                  {!isFE_FI && (
                    <td>
                      <InputField
                        type="number"
                        placeholder="Length in cm's"
                        value={inputRow.length}
                        onChange={(e) =>
                          setInputRow((prev) => ({
                            ...prev,
                            length: e.target.value,
                          }))
                        }
                      />
                    </td>
                  )}
                  {!isFE_FI && (
                    <td>
                      <InputField
                        type="number"
                        placeholder="Breadth in cm's"
                        value={inputRow.breadth}
                        onChange={(e) =>
                          setInputRow((prev) => ({
                            ...prev,
                            breadth: e.target.value,
                          }))
                        }
                      />
                    </td>
                  )}
                  {!isFE_FI && (
                    <td>
                      <InputField
                        type="number"
                        placeholder="Height in cm's"
                        value={inputRow.height}
                        onChange={(e) =>
                          setInputRow((prev) => ({
                            ...prev,
                            height: e.target.value,
                          }))
                        }
                      />
</td>
                   )}
                   {isLE_LI && (
                     <td>
                       {inputRow.length && inputRow.breadth && inputRow.height
                         ? (
                             (parseFloat(inputRow.length) *
                               parseFloat(inputRow.breadth) *
                               parseFloat(inputRow.height)) /
                             1000000
                           ).toFixed(2)
                         : "0.00"}
                     </td>
                   )}
                   {formik.values.nature_of_cargo === "Temperature Control" && (
                    <td>
                      <InputField
                        type="number"
                        placeholder="Temperature in °C"
                        value={inputRow.temperature}
                        onChange={(e) =>
                          setInputRow((prev) => ({
                            ...prev,
                            temperature: e.target.value,
                          }))
                        }
                      />
                    </td>
                  )}
                  <td className="text-center">
                    <AddCircleOutlineIcon
                      onClick={handleAddRow}
                      style={{
                        cursor: "pointer",
                        color: "green",
                        fontSize: 28,
                      }}
                    />
                  </td>
                </tr>
 
                {/* Display Rows */}
                {formik.values.containers.map((container, index) => (
                  <tr key={index}>
                    {!isLE_LI && <td>{container.container_type}</td>}
                    {!isLE_LI && <td>{container.container_weight}</td>}
                    {!isFE_FI && <td>{container.container_length}</td>}
                    {!isFE_FI && <td>{container.container_breadth}</td>}
{!isFE_FI && <td>{container.container_height}</td>}
                     {isLE_LI && (
                       <td>
                         {container.container_length && container.container_breadth && container.container_height
                           ? (
                               (parseFloat(container.container_length) *
                                 parseFloat(container.container_breadth) *
                                 parseFloat(container.container_height)) /
                               1000000
                             ).toFixed(2)
                           : "0.00"}
                       </td>
                     )}
                     {formik.values.nature_of_cargo ===
                       "Temperature Control" && (
                       <td>{container.container_temperature}</td>
                     )}
                    <td className="text-center">
                      <DeleteOutlineIcon
                        onClick={() => handleRemoveRow(index)}
                        style={{
                          cursor: "pointer",
                          color: "red",
                          fontSize: 28,
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
 
            {hasFieldError("containers") && (
              <div className="text-danger small mt-1">
                {getFieldError("containers")}
              </div>
            )}
          </div>
 
          <div className="row mb-3">
            <div className="col-sm-6 col-md-4">
              <label className="form-label">CHA Services Required?</label>
              <Select
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                ]}
                value={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                ].find((option) => option.value === formik.values.cha_required.toLocaleLowerCase())}
                onChange={(option) =>
                  formik.setFieldValue("cha_required", option?.value || "")
                }
                onBlur={() => formik.setFieldTouched("cha_required", true)}
                isClearable
              />
            </div>
 
            <div className="col-4">
              <label className="form-label">Remarks</label>
              <InputField
                name="remarks"
                placeholder="Enter Remarks"
                value={formik.values.remarks}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
        </div>
        {/* Action Buttons */}
        <div className="text-end mt-3">
          <Button
            text="Update Enquiry"
            variant="primary"
            type="submit"
            onClick={() => {
              setShowConfirm(true);
            }}
          />
        </div>
      </form>
 
      {/* Confirmation Modal */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to update this enquiry?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirm}>
            Yes, Update
          </Button>
        </Modal.Footer>
      </Modal>
 
      {/* Success Modal */}
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Enquiry updated successfully!</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSuccessClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
 
export default EditEnquiry;